import { render, staticRenderFns } from "./Recommendation.vue?vue&type=template&id=2318e730&scoped=true"
import script from "./Recommendation.vue?vue&type=script&lang=js"
export * from "./Recommendation.vue?vue&type=script&lang=js"
import style0 from "./Recommendation.vue?vue&type=style&index=0&id=2318e730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2318e730",
  null
  
)

export default component.exports